'use client'

import { cva, VariantProps } from 'class-variance-authority'
import { motion } from 'framer-motion'
import { FC, HTMLAttributes } from 'react'

import BilPlusIcon from '@/assets/icons/BilPlusIcon'
import { cn } from '@/lib/utils'

export const spinnerVariants = cva('flex bg-primary/10 items-center justify-center', {
  defaultVariants: {
    layout: 'fullscreen',
  },
  variants: {
    layout: {
      fullscreen: 'h-screen w-screen',
      inline: 'h-[20px] w-[20px]',
      section: 'h-[200px]',
    },
  },
})

type Props = {
  size?: string
} & HTMLAttributes<HTMLElement> &
  VariantProps<typeof spinnerVariants>

/**
 * Full screen loading indicator.
 */
const FullScreenSpinner: FC<Props> = ({ layout, size = '100px', ...props }) => {
  return (
    <div {...props} className={cn(spinnerVariants({ layout }), props.className)}>
      <div className="animate-bounce">
        <motion.div
          animate={{ scale: 1 }}
          className="flex items-center justify-center rounded-[12px] bg-primary p-[10px]"
          initial={{ scale: 0.5 }}
          style={{ height: size, width: size }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        >
          <BilPlusIcon className="size-10 text-black" />
        </motion.div>
      </div>
    </div>
  )
}

export default FullScreenSpinner
